import { Card, Button, Dropdown } from "react-bootstrap"
import { Link, useNavigate } from "react-router-dom"
import {
  Icon,
  CustomDropdownToggle,
  CustomDropdownMenu,
  LinkList,
} from "../../../components"
import Layout from "../../../layout/default"
import Block from "../../../components/Block/Block"
import DataTable from "../../../components/DataTable/DataTable.js"
import React, { useEffect, useState } from "react"
import lead_assignmentService from "../services/Lead_assignmentService"

const Lead_assignmentList = () => {
  const navigate = useNavigate()
  const [leadData, setLead] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchAll()
  }, [])

  const fetchAll = async () => {
    try {
      setLoading(true)
      await Promise.all([fetchLeadList()])
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const fetchLeadList = async () => {
    const response = await lead_assignmentService.getLead_assignmentList()
    setLead(response)
  }

  const handleDeleteLead = async (leadId) => {
    try {
      setLoading(true)
      await lead_assignmentService.deleteLead_assignment(leadId)
      const data = leadData.filter((rows) => rows.id != leadId)
      setLead(data)
      setLoading(false)
    } catch (error) {
      console.log("Error deleting lead:", error)
      setLoading(false)
    }
  }

  const handleCreateLead = () => {
    navigate("/lead-assignment/new")
  }

  const leadColumns = [
    {
      name: "id",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "lead",
      selector: (row) => row.lead,
      sortable: true,
    },
    {
      name: "lawyer",
      selector: (row) => row.lawyer,
      sortable: true,
    },
    {
      name: "campaign",
      selector: (row) => row.campaign,
      sortable: true,
    },
    {
      name: "assignment_order",
      selector: (row) => row.assignment_order,
      sortable: true,
    },
    {
      name: "actions",
      cell: (row) => (
        <div className="text-end w-100">
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              as={CustomDropdownToggle}
              className="btn btn-sm btn-icon btn-zoom me-n1"
            >
              <Icon name="more-v" />
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="dropdown-menu-sm"
              as={CustomDropdownMenu}
              align="end"
            >
              <div className="dropdown-content py-1">
                <LinkList className="link-list-hover-bg-primary link-list-md">
                  <Link
                    to={`/lead-assignment/edit/${row.id}`}
                    className="dropdown-item"
                  >
                    <Icon name="edit" />
                    <span>Edit</span>
                  </Link>
                  <button
                    className="dropdown-item"
                    onClick={() => handleDeleteLead(row.id)}
                  >
                    <Icon name="trash" />
                    <span>Delete</span>
                  </button>
                </LinkList>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
      sortable: false,
    },
  ]

  return (
    <Layout title="Leads" content="container" loading={loading}>
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Asignación</Block.Title>
            <nav>
              <ol className="breadcrumb breadcrumb-arrow mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Leads
                </li>
              </ol>
            </nav>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Button
                  className="d-md-none"
                  size="md"
                  variant="primary"
                  onClick={handleCreateLead}
                >
                  <Icon name="plus" />
                  <span>Añadir</span>
                </Button>
              </li>
              <li>
                <Button
                  className="d-none d-md-inline-flex"
                  variant="primary"
                  onClick={handleCreateLead}
                >
                  <Icon name="plus" />
                  <span>Añadir Asignación</span>
                </Button>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          {!loading && (
            <DataTable
              tableClassName="data-table-head-light table-responsive"
              data={leadData}
              columns={leadColumns}
              expandableRows
              actions
              searchByList={["id", "lead", "lawyer", "campaign"]}
            />
          )}
        </Card>
      </Block>
    </Layout>
  )
}

export default Lead_assignmentList
